export const circle = `border-radius: 50%`;
export const concealScrollbars = `-ms-overflow-style: none; scrollbar-width: none; &::-webkit-scrollbar { display: none; }`;
export const defaultBoxShadow = `box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1)`;
export const rainbowGradient =
  'background: radial-gradient(50% 50% at 50% 50%, #fff 0%, rgba(255, 255, 255, 0) 100%), conic-gradient(from -90deg at 50% 50%, #c0f -3.06deg, #f00 21.31deg, #f90 56.93deg, #ffe600 105.68deg, #fff500 141.31deg, #3f0 186.31deg, #0ff 236.94deg, #00f7ff 250.06deg, #000aff 293.19deg, #c0f 356.94deg, #f00 381.31deg);';

const utils = {
  circle,
  concealScrollbars,
  defaultBoxShadow,
  rainbowGradient,
} as const;

export default utils;
